export const backgroundVideoInit = () => {
    const videos = Array.from(document.querySelectorAll('.background-video video'));

if (videos) {
    videos.forEach(video => {
        const videoSrc = video.querySelector('source');
        
            if (window.matchMedia('(min-width: 992px)').matches) {
                if (videoSrc.dataset.src && videoSrc.src !== videoSrc.dataset.src) {
                    videoSrc.src = videoSrc.dataset.src;
                    video.load();
                }
            } else {
                if (videoSrc.dataset.mobile && videoSrc.src !== videoSrc.dataset.mobile) {
                    videoSrc.src = videoSrc.dataset.mobile;
                    video.load();
                }
            }
        })
    }
}